/**
 * App.tsx — root that wires Provider + ErrorBoundary + RouterProvider.
 *
 * `index.tsx` does the literal `createRoot().render(<App/>)` so this file
 * stays free of CRA-specific boilerplate.
 */

import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';
import { router } from '../routes/routes';
import { store } from '../redux/store';

export default function App() {
	return (
		<ErrorBoundary>
			<Provider store={store}>
				<RouterProvider router={router} />
			</Provider>
		</ErrorBoundary>
	);
}
